import React from 'react';
import { Stack, Typography, Box } from '@mui/material';
import { Icon } from './Icon';
import { PreviewImage } from './PreviewImage';

interface MenuItem {
  id: string;
  name: string;
  image: string;
}

const ImageWrapper = ({ children }: { children: React.ReactNode }) => (
  <Box
    sx={{
      position: 'relative',
      width: '100%',
      paddingTop: '75%', // 4:3 aspect ratio (height = 75% of width)
      borderRadius: '12px',
      overflow: 'hidden',
    }}
  >
    <Box
      sx={{
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
      }}
    >
      {children}
    </Box>
  </Box>
);

const PlaceholderImage = () => (
  <Box
    sx={{
      width: '100%',
      height: '100%',
      backgroundColor: '#D9D9D9',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      borderRadius: '12px',
    }}
  >
    <Icon name="menu" />
  </Box>
);

export const VenueMenuItems = ({ menuItems }: { menuItems: MenuItem[] }) => {
  const menuItemsToDisplay = menuItems;

  return (
    <Stack direction="column" gap="24px">
      <Box
        display="grid"
        gridTemplateColumns={{
          xs: '1fr',
          sm: '1fr 1fr',
          md: '1fr 1fr 1fr 1fr',
        }}
        gap={2}
      >
        {menuItemsToDisplay.map((item) => (
          <Stack key={item.id} spacing={1} alignItems="flex-start">
            <ImageWrapper>
              {item.image ? (
                <PreviewImage alt={item.name} src={item.image} />
              ) : (
                <PlaceholderImage />
              )}
            </ImageWrapper>

            <Typography
              sx={{
                fontSize: '16px',
                lineHeight: '150%',
                fontWeight: 500,
                textAlign: 'center',
              }}
            >
              {item.name}
            </Typography>
          </Stack>
        ))}
      </Box>
    </Stack>
  );
};
